const adTagUrlDev =
  'https://pubads.g.doubleclick.net/gampad/ads?' +
  'sz=640x480&iu=/124319096/external/single_ad_samples&ciu_szs=300x250&' +
  'impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&' +
  'cust_params=deployment%3Ddevsite%26sample_ct%3Dlinear&correlator=';

export async function getAdTagURL(
  adUnitPath: string,
  isMobile: boolean,
  canonicalUrl: string,
) {
  if (window.ENV === 'development') {
    return adTagUrlDev;
  }

  let adTagUrlProd = new URL(
    isMobile
      ? 'https://fast.nexx360.io/vast?tag_id=ghpqeumu&vf_id=1179&gdpr=1'
      : 'https://fast.nexx360.io/vast?tag_id=g5y095wv&vf_id=1178&gdpr=1',
  );

  return new Promise<string>((res) => {
    window.__tcfapi('addEventListener', 2, (tcData) => {
      //CMP is not ready
      if (tcData == null || typeof tcData.eventStatus === 'undefined') return;

      //User interaction is not done yet
      if (
        tcData.eventStatus !== 'useractioncomplete' &&
        tcData.eventStatus !== 'tcloaded'
      )
        return;

      adTagUrlProd.searchParams.append('url', canonicalUrl);
      adTagUrlProd.searchParams.append('gdpr_consent', tcData.tcString);

      window.__tcfapi('removeEventListener', 2, () => {}, tcData.listenerId);

      res(adTagUrlProd.toString());
    });
  });
}
